export default __webpack_public_path__ + "static/16-ef403276135ac088c628c25fcae049bc.webp";